import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AccessRole } from 'src/app/app.constants';
import { AuthService } from '../services/auth.service';

export const roleGuard =
  (minRole: AccessRole): CanActivateFn =>
  () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.canExecuteAction(minRole) ? true : router.createUrlTree(['/']);
  };
